import { Box, Button, Chip, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

interface ClientBulkActionBarProps {
  selectedJobsCount: number;
  onApprove: () => void;
  onClear: () => void;
  isLoading?: boolean;
}

export default function ClientBulkActionBar({
  selectedJobsCount,
  onApprove,
  onClear,
  isLoading = false,
}: ClientBulkActionBarProps) {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 80, // Account for header height + spacing
        zIndex: 5, // Lower than header
        backgroundColor: "#f8f9fa", // Light gray background
        border: "1px solid #e9ecef", // Subtle border
        color: "#495057", // Dark gray text
        p: 2,
        mb: 2,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Chip
          label={`${selectedJobsCount} selected`}
          size="small"
          sx={{
            backgroundColor: "#e3f2fd", // Light blue background
            color: "#1976d2", // Blue text
            fontWeight: "medium",
          }}
        />

        <Typography
          variant="body2"
          sx={{ color: "#6c757d", fontWeight: "medium" }}
        >
          Mark selected jobs as approved
        </Typography>

        <LoadingButton
          variant="contained"
          loading={isLoading}
          disabled={isLoading || selectedJobsCount === 0}
          onClick={onApprove}
          sx={{
            backgroundColor: "#28a745", // Professional green
            color: "white",
            fontWeight: "medium",
            px: 3,
            py: 1,
            borderRadius: 2,
            "&:hover": {
              backgroundColor: "#218838", // Darker green on hover
            },
            "&:disabled": {
              backgroundColor: "#6c757d",
              color: "#ffffff",
            },
          }}
        >
          Mark as Approved
        </LoadingButton>
      </Box>

      <Button
        variant="text"
        onClick={onClear}
        sx={{
          color: "#6c757d",
          fontWeight: "medium",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
            color: "#495057",
          },
        }}
      >
        Clear Selection
      </Button>
    </Box>
  );
}
